import React, { useState, useEffect, useRef } from 'react';
import connect from "react-redux/es/connect/connect";
import { setCurrentNavPage } from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import DocumentApplicationFilters from "../../components/Filters/Statistics/DocumentApplicationFilters";
import FacturationStatisticsBloc from "../../components/Admin/statisctics/FacturationStatisticsBloc";
import PaymentStatisticsBloc from "../../components/Admin/statisctics/PaymentStatisticsBloc";
import NotPaidInvoices from "../../components/Admin/statisctics/NotPaidInvoices";
import { urlFiltersParser } from 'utils';
import _ from "i18n";
import { fetchDocumentsAppRef } from "../../actions/thunks/documents";
import queryString from "query-string";
import { castArray } from "lodash";
import { setCurrentClient } from '../../actions/actions/auth';

const StatisticIFramePage = ({
  appRef,
  auth,
  setCurrentNavPage,
  fetchDocumentsAppRef,
  setCurrentClient
}) => {

  const [header, setHeader] = useState("");
  const [showTitle, setShowTitle] = useState(true);
  const prevCurrentClient = useRef(auth.currentClient);

  const initFromFilter = (group) => {
    const urlParams = queryString.parse(location.search);

    if (!urlParams.filters) {
      return [];
    }

    let filter = urlFiltersParser(urlParams.filters);

    if (!filter || filter.length <= 0) {
      return [];
    }

    let appFilter = filter.filter(item => group === item.property);

    if (!appFilter || appFilter.length <= 0 || !appFilter[0].value) {
      return [];
    }
    return castArray(appFilter[0].value);
  };

  // componentDidMount
  useEffect(() => {
    setCurrentNavPage("STATISTICS-IFRAME");
    let appRefsFilter = initFromFilter('appRefs');
    let clientIdFilter = initFromFilter('clientId');
    let showTitleFilter = initFromFilter('showTitle');

    if (showTitleFilter[0]) {
      setShowTitle(showTitleFilter[0]);
    }

    let { paymentClients } = auth.user;

    clientIdFilter.forEach(id => {
      if (paymentClients.length > 0) {
        let organization = paymentClients.find(item => item.id == id);

        if (organization !== undefined) {
          setCurrentClient(organization);
        }
      }
    });

    if (showTitleFilter[0] && showTitleFilter[0] == '1') {
      fetchDocumentsAppRef(auth.currentClient ? auth.currentClient.id : null).then(() => {
        appRefsFilter.forEach(id => {
          if (appRef.length > 0) {
            let appRefs = appRef.find(item => item.id == id);
            if (appRefs !== undefined) {
              setHeader(appRefs.nameFr);
            }
          }
        });
      });
    }
  }, []);

  // componentDidUpdate
  useEffect(() => {
    if (prevCurrentClient.current !== auth.currentClient) {
      let appRefsFilter = initFromFilter('appRefs');
      fetchDocumentsAppRef(auth.currentClient ? auth.currentClient.id : null).then(() => {
        appRefsFilter.forEach(id => {
          if (appRef.length > 0) {
            let appRefs = appRef.find(item => item.id == id);
            if (appRefs !== undefined) {
              setHeader(appRefs.nameFr);
            }
          }
        });
      });
    }
    prevCurrentClient.current = auth.currentClient;
  }, [auth.currentClient]);

  return (
    <div>
      {showTitle == '1' ? (
        <PageHeader
          header={_('stats')}
          subHeader={header}
          icon="STATISTICS_HEADER"
        />
      ) : null}

      <div className="ttp-tab-container">
        <div className="ttp-tab-selector hidden">
          <DocumentApplicationFilters />
        </div>
        <FacturationStatisticsBloc showInNewTab={true} />

        <PaymentStatisticsBloc showInNewTab={true} />

        <NotPaidInvoices />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  appRef: state.appRefFilter.items,
  auth: state.auth,
});

const mapDispatchToProps = {
  setCurrentNavPage,
  fetchDocumentsAppRef,
  setCurrentClient
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticIFramePage);


// WEBPACK FOOTER //
// ./app/pages/Admin/StatisticIFramePage.js